import React, { Component } from "react";
import { Form } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import { withRouter } from "react-router-dom";
import { SeatingArea } from "./InsideSubscriptionScreen/SeatingArea";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

export class GenralEditScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      hasSetSubscriptionProps: false,
      openModal: false,
      openSuccessModal: false,
      checked: false,
      selectedTab: 4,
      displayHomeScreen: false,
      displayCasualFineAndFastFood: false,

      // Display Page Screen

      displaySeating: false,
      displayScanAndPay: false,
      displayMenuSetup: false,
      displayOrdering: false,
      displayFoodMenuSetup: false,
      displayFoodOrdering: false,
      displayInsideScreen: false,
      displayWalkinWaitlist: false,
      displayReservations: false,

      // toggle Click State
      seatingArea: false,
      scanAndPay: false,
      menuSetup: false,
      ordering: false,
      foodMenuSetup: false,
      foodOrdering: false,
      walkinWaitlist: false,
      reservation: false,
      takeAway: false,
      selfServe: false,
      driveThru: false,
      curbSide: false,
      //Seating State
      displayScreen: true,
      all_seating_area: [],
      selected_seating_area: [{ id: 1 }],
      uploadMenu: [],
      highchair: false,
      handicapAccess: false,
      roomNumberSeatingRequest: false,
      tableManagement: false,
      seatingCapacity: "",
      autoAcceptPaxLimit: "",
      tableturnAroundTime: "",
      reservationTableAroundTime: false,
      reservationTableAroundTimeText: "",
      //Walkin Waitlist States
      distance: "",
      requestPeriod: "",
      minimumPerson: "",
      walkinWaitlistTableKeptForPopup: false,
      walkinWaitlistTableKeptFor: "",
      //Reservation State
      minimumPersonReservation: "",
      reservationTableKeptForPopup: false,
      reservationTableKeptFor: "",
      sameDayAllowed: false,
      reservationMinLead: false,
      reservationMinLeadTime: "",
      reservationCutOffTime: false,
      reservationCutOffTimeText: "",
      maximumDays: "",
      reservationCapacity: "",
      reservationTimeSlots: false,
      reservationTimeSlotsText: "",
      //Casual Dining Upload Menu
      casualDiningUploadMenu: [],
      //Fast Food Upload Menu
      fastFoodUploadMenu: [],

      errors: {},

      resTabKeptForError: false,
      resMinLeadTimeError: false,
      resCutOffTimeError: false,
      resTimeSlotError: false,
      walkinWaitlistError: false,
    };
    this.displaySeatingArea = this.displaySeatingArea.bind(this);
    this.handleSeatingArea = this.handleSeatingArea.bind(this);

    /************** Seating Page Condition  **************/
    this.onDrop = this.onDrop.bind(this);
    this.handleChangehighchair = this.handleChangehighchair.bind(this);
    this.handleChangehandicapAccess = this.handleChangehandicapAccess.bind(
      this
    );
    this.handleChangeroomNumberSeatingRequest = this.handleChangeroomNumberSeatingRequest.bind(
      this
    );
    this.handleChangetableManagement = this.handleChangetableManagement.bind(
      this
    );
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.subscription) &&
      !nextState.hasSetSubscriptionProps
    ) {
      let selected_seating_area = nextProps.onboarding.selected_seating_area;
      if (!isEmpty(selected_seating_area[0])) {
        if (
          isEmpty(selected_seating_area[0]._id) &&
          selected_seating_area.length > 0
        ) {
          selected_seating_area = nextProps.subscription.filter((seating) =>
            selected_seating_area.includes(seating._id)
          );
        }
      }
      return {
        all_seating_area: nextProps.subscription,
        displayHomeScreen: !isEmpty(
          nextProps.onboarding.display_subscription_home
        )
          ? nextProps.onboarding.display_subscription_home
          : false,
        seatingArea: !isEmpty(nextProps.onboarding.seating_area)
          ? nextProps.onboarding.seating_area
          : false,
        menuSetup: !isEmpty(nextProps.onboarding.menuSetup)
          ? nextProps.onboarding.menuSetup
          : false,
        ordering: !isEmpty(nextProps.onboarding.ordering)
          ? nextProps.onboarding.ordering
          : false,
        foodMenuSetup: !isEmpty(nextProps.onboarding.food_menu_setup)
          ? nextProps.onboarding.food_menu_setup
          : false,
        foodOrdering: !isEmpty(nextProps.onboarding.food_ordering)
          ? nextProps.onboarding.food_ordering
          : false,
        // displayScreen: nextProps.onboarding.displayScreen,
        displaySeating: !isEmpty(nextProps.onboarding.displayScreen)
          ? nextProps.onboarding.displayScreen
          : false,
        // menu_setup: nextProps.onboarding.// menu_setup,
        selected_seating_area: !isEmpty(
          nextProps.onboarding.selected_seating_area
        )
          ? nextProps.onboarding.selected_seating_area
          : [],
        highchair: !isEmpty(nextProps.onboarding.highchair)
          ? nextProps.onboarding.highchair
          : false,
        handicapAccess: !isEmpty(nextProps.onboarding.handicap)
          ? nextProps.onboarding.handicap
          : false,
        roomNumberSeatingRequest: !isEmpty(nextProps.onboarding.room_number)
          ? nextProps.onboarding.room_number
          : false,
        tableManagement: !isEmpty(nextProps.onboarding.table_management)
          ? nextProps.onboarding.table_management
          : false,
        seatingCapacity: !isEmpty(nextProps.onboarding.seating_capacity)
          ? nextProps.onboarding.seating_capacity
          : "",
        autoAcceptPaxLimit: !isEmpty(nextProps.onboarding.auto_accept_pax)
          ? nextProps.onboarding.auto_accept_pax
          : "",
        tableturnAroundTime: !isEmpty(nextProps.onboarding.table_turn_around)
          ? nextProps.onboarding.table_turn_around
          : "",
        walkinWaitlist: !isEmpty(nextProps.onboarding.walk_in_or_waitlist)
          ? nextProps.onboarding.walk_in_or_waitlist
          : false,
        reservation: !isEmpty(nextProps.onboarding.reservation)
          ? nextProps.onboarding.reservation
          : false,
        distance: !isEmpty(nextProps.onboarding.distance)
          ? nextProps.onboarding.distance
          : "",
        requestPeriod: !isEmpty(nextProps.onboarding.request_period)
          ? nextProps.onboarding.request_period
          : "",
        minimumPerson: !isEmpty(nextProps.onboarding.minimum_person)
          ? nextProps.onboarding.minimum_person
          : "",
        walkinWaitlistTableKeptFor: !isEmpty(
          nextProps.onboarding.walk_in_wait_list_table_kept_for
        )
          ? nextProps.onboarding.walk_in_wait_list_table_kept_for
          : "",
        minimumPersonReservation: !isEmpty(
          nextProps.onboarding.minimum_person_reservation
        )
          ? nextProps.onboarding.minimum_person_reservation
          : "",
        reservationTableKeptFor: !isEmpty(
          nextProps.onboarding.reservation_table_kept_for
        )
          ? nextProps.onboarding.reservation_table_kept_for
          : "",
        sameDayAllowed: !isEmpty(nextProps.onboarding.sameDayAllowed)
          ? nextProps.onboarding.sameDayAllowed
          : false,
        reservationMinLeadTime: !isEmpty(nextProps.onboarding.minimum_lead_time)
          ? nextProps.onboarding.minimum_lead_time
          : "",
        reservationCutOffTimeText: !isEmpty(nextProps.onboarding.cut_off_time)
          ? nextProps.onboarding.cut_off_time
          : "",
        maximumDays: !isEmpty(nextProps.onboarding.maximum_days)
          ? nextProps.onboarding.maximum_days
          : "",
        reservationCapacity: !isEmpty(nextProps.onboarding.reservation_capacity)
          ? nextProps.onboarding.reservation_capacity
          : "",
        reservationTimeSlotsText: !isEmpty(
          nextProps.onboarding.reservation_time_slot
        )
          ? nextProps.onboarding.reservation_time_slot
          : "",
        hasSetSubscriptionProps: true,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      console.log(nextProps.auth.loader);
      return {
        loader: nextProps.auth.loader,
      };
    }
    return null;
  }

  /***************************************
   * @DESC Seating Area Toggle Handlers
   **************************************/
  displaySeatingArea(displaySeating) {
    this.setState({
      displaySeating,
    });
  }

  handleSeatingArea(seatingArea) {
    this.setState({
      seatingArea,
      displayScreen: false,
      walkinWaitlist: this.state.walkinWaitlist === false ? false : true,
      reservation: this.state.reservation === false ? false : true,
    });
  }

  onSeatingChangeHandler = (e) => {
    this.setState({
      displaySeating: false,
      displayCasualFineAndFastFood: false,
    });
  };
  onSeatingAreaSubmit = (e) => {
    this.setState({
      displaySeating: false,
      displayInsideScreen: true,
      seatingArea: true,
    });
  };

  /****************************************************************
   * @DESC Seating Area Page All Functions Start
   ****************************************************************/
  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  handleChangehighchair(highchair) {
    this.setState({
      highchair,
      actionButton: true,
    });
  }
  handleChangehandicapAccess(handicapAccess) {
    this.setState({
      handicapAccess,
      actionButton: true,
    });
  }
  handleChangeroomNumberSeatingRequest(roomNumberSeatingRequest) {
    this.setState({
      roomNumberSeatingRequest,
      actionButton: true,
    });
  }
  handleChangetableManagement(tableManagement) {
    this.setState({
      tableManagement,
      actionButton: true,
    });
  }

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /*********************************************
   * @DESC - onLocated Inside Array Selector
   *********************************************/
  onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = this.state.selected_seating_area;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    this.setState({
      selected_seating_area: restaurantTypeArray,
      actionButton: true,
    });
  };

  /*********************************
   * @DESC Multiple Image Upload
   ********************************/
  onDrop(picture) {
    this.setState({
      uploadMenu: picture,
      actionButton: true,
    });
  }
  reservationTableAroundTimeOpen = () => {
    this.setState({
      reservationTableAroundTime: true,
    });
  };

  reservationTableAroundTimeClosed = () => {
    this.setState({
      reservationTableAroundTime: false,
      actionButton: false,
    });
  };

  reservationTableAroundTimeTextButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      tableturnAroundTime: type,
      reservationTableAroundTime: false,
      actionButton: true,
    });
  };

  /****************************************************************
   * @DESC Seating Area Page All Functions End
   ****************************************************************/

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onboarding._id && this.props.auth.user.VendorUser._id) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        display_subscription_home: this.state.displayHomeScreen,
        seating_area: this.state.seatingArea,
        menuSetup: this.state.menuSetup,
        ordering: this.state.ordering,
        food_menu_setup: this.state.foodMenuSetup,
        food_ordering: this.state.foodOrdering,
        displayScreen: this.state.displayScreen,
        selected_seating_area: this.state.selected_seating_area,
        // menu_setup: this.state.uploadMenu,
        highchair: this.state.highchair,
        handicap: this.state.handicapAccess,
        room_number: this.state.roomNumberSeatingRequest,
        table_management: this.state.tableManagement,
        seating_capacity: this.state.seatingCapacity,
        auto_accept_pax: this.state.autoAcceptPaxLimit,
        table_turn_around: this.state.tableturnAroundTime,
        walk_in_or_waitlist: this.state.walkinWaitlist,
        reservation: this.state.reservation,
        distance: this.state.distance,
        request_period: this.state.requestPeriod,
        minimum_person: this.state.minimumPerson,
        walk_in_wait_list_table_kept_for: this.state.walkinWaitlistTableKeptFor,
        minimum_person_reservation: this.state.minimumPersonReservation,
        reservation_table_kept_for: this.state.reservationTableKeptFor,
        sameDayAllowed: this.state.sameDayAllowed,
        minimum_lead_time: this.state.reservationMinLeadTime,
        cut_off_time: this.state.reservationCutOffTimeText,
        maximum_days: this.state.maximumDays,
        reservation_capacity: this.state.reservationCapacity,
        reservation_time_slot: this.state.reservationTimeSlotsText,
      };
      this.props.create_and_update_restaurant(formData);
      this.setState({
        editButton: false,
        actionButton: false,
      });
    }
  };

  renderSeatingScreen = () => {
    return (
      <React.Fragment>
        <div className="subscription_component_onboarding_main">
          <SeatingArea
            onSeatingChangeHandler={this.onSeatingChangeHandler}
            seatingAreaScreenNext={this.onSeatingAreaSubmit}
            displayScreen={this.state.displayScreen}
            state={this.state}
            onLocatedInsideArraySelector={this.onLocatedInsideArraySelector}
            onDrop={this.onDrop}
            onClickDisplayScreen={this.onClickDisplayScreen}
            onClickDisplayScreenClosed={this.onClickDisplayScreenClosed}
            handleChangehighchair={this.handleChangehighchair}
            handleChangehandicapAccess={this.handleChangehandicapAccess}
            handleChangeroomNumberSeatingRequest={
              this.handleChangeroomNumberSeatingRequest
            }
            handleChangetableManagement={this.handleChangetableManagement}
            onFocusOut={this.onFocusOut}
            onChange={this.onChange}
            errors={this.state.errors}
            reservationTableAroundTimeOpen={this.reservationTableAroundTimeOpen}
            reservationTableAroundTimeClosed={
              this.reservationTableAroundTimeClosed
            }
            reservationTableAroundTimeTextButtonClick={
              this.reservationTableAroundTimeTextButtonClick
            }
          />
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    // const { displayHomeScreen } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/seatingdashboard"
                displayText="Back"
              />
              <div className="col-12 onboarding_process_screen_left overflow-visible bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div>
                  <TopTextReusableComponent
                    headingText="Seating General Settings"
                    displayEdit={this.state.editButton}
                    onClickEdit={this.editClick}
                  />
                </div>
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  <div className="onboarding_process_screen-left-mapinside">
                    {this.renderSeatingScreen()}
                  </div>
                </Form>
              </div>
            </div>
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

GenralEditScreen.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.category.seating_area,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(GenralEditScreen));
